import React, { useState } from 'react';
import { ReactComponent as LogoMini } from '@assets/images/logo-e-pu.svg';

import { ReactComponent as Menu } from './assets/menu.svg';
import { Container, OverLay } from './styles';
import { Notifications } from './components/Notifications';
import { Sidebar } from './components/Sidebar';

export const Header: React.FC = () => {
  const [showSideBar, setSideBar] = useState(false);

  const openSideBar = () => setSideBar(!showSideBar);
  const closeSideBar = () => setSideBar(false);

  return (
    <Container>
      <Sidebar showSideBar={showSideBar} closeSidebar={closeSideBar} />
      {showSideBar && <OverLay />}
      <button type="button" onClick={openSideBar}>
        <Menu />
      </button>
      {/* <LogoMini /> */}
      <span>e-PU</span>

      <Notifications />
    </Container>
  );
};
